import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';

import { QUERY_LINKS } from '../../utils/queries';

import Carousel from 'react-bootstrap/Carousel';

import spinner from '../../assets/spinner.gif';
import LinkItem from '../LinkItem';
import DealGrid from '../DealGrid';

import './AffiliateLinks.css';

function AffiliateLinks() {
  const dispatch = useDispatch();

  const [links, setLinks] = useState([]);
  const [bannerLinks, setBannerLinks] = useState([]);

  const { loading, data } = useQuery(QUERY_LINKS);

  useEffect(() => {
    if (data) {
      setLinks(data.links.filter(link => link.active && link.name));
      setBannerLinks(data.links.filter(link => link.active && link.bannerImage));
    }
  }, [data, loading, dispatch]);

  return (
    <>
      <div className="my-2">

      { ! loading && bannerLinks.length ?
          <Carousel interval={2000}>
            { bannerLinks.map( link =>
            <Carousel.Item key={link._id}>
              <a href={link.url}>
                {link.bannerImage ? <img alt={link.name} src={`/image/${link.bannerImage}`} /> : null}
              </a>
              <Carousel.Caption>
                {/*<h3>{link.name}</h3>*/}
              </Carousel.Caption>
            </Carousel.Item>) }
          </Carousel> : null}

        {/*
        From AliExpress Ad Center:
        https://portals.aliexpress.com/affiportals/web/ad_center.htm?spm=0._cps_dada.0.0.718cERn9ERn9CB#activeKey=promoteCampaign
        <div className="banner">
          <a href='https://s.click.aliexpress.com/e/_c34ILmyf?bz=300*250' target='_parent'>
            <img src='https://ae01.alicdn.com/kf/S3619e57974f148d087c950fe497cdf55q/300x250.jpg' alt=" " />
          </a>
        </div>
        */}


        <h2>Click for Curated Daily Discounts</h2>
        <p className="disclaimer">When you shop affiliate links at Amazon, AliExpress and other sites, we may receive a commission on qualifying purchases.</p>

        <div className="clearfix"></div>

        <DealGrid />


        <h2>Our Recommended Products</h2>

        {loading ? <img src={spinner} alt="loading" /> :
          (links.length ?
            <div className="flex-row">
              {links.map(link => (
                <LinkItem key={link._id} link={link}/>
              ))}
            </div> : <h3>You haven't added any links yet!</h3>
          )}
      </div>
    </>
  );
}

export default AffiliateLinks;
